export enum PostalPreference {
	Home = 605340000,
	Work,
}
